import type { InputDevice } from './types';

/**
 * Last active input device — UI screens read this to show the right
 * button hints (keyboard vs gamepad vs touch). Set by InputManager.poll.
 */
let device: InputDevice = 'keyboard';

export function setActiveDevice(d: InputDevice): void {
  device = d;
}

export function getActiveDevice(): InputDevice {
  return device;
}

/** Touch-first hardware (phones, tablets): the primary pointer is coarse. */
export function isCoarsePointer(): boolean {
  return window.matchMedia?.('(pointer: coarse)').matches === true || 'ontouchstart' in window;
}
